module.exports = __webpack_public_path__ + "img/19n.ed5432a7.png";